import React, { createContext, useCallback, useEffect, useState } from "react";
import useFetch from "../hooks/useFetch";
import { getProjectPapers } from "../api/Api";

const InitiativeContext = createContext(null);
const PAPERS_PER_PAGE = 8; // Number of papers to display per page
// This context provider is used to fetch and provide project-related data

function InitiativeContextProvider({ children, projectId }) {
  const [papers, setPapers] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: PAPERS_PER_PAGE,
    totalItems: 0,
  }); // Pagination state
  const [paperStatusFilter, setPaperStatusFilter] = useState('all');
  const { currentPage, pageSize, totalItems } = pagination; // Destructure pagination state

  // Fetch project details using a custom hook
  const { data, error, loading, refresh } = useFetch(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/projects/${projectId}`
  );

  const fetchPapers = useCallback(async () => {
    console.log("Fetching papers for projectId:", projectId, "at page:", currentPage, "with pageSize:", pageSize);
    if (!projectId) return; // Ensure projectId is available

    try {
      const response = await getProjectPapers(
        projectId, 
        currentPage, 
        pageSize,
        paperStatusFilter === 'all' ? '' : paperStatusFilter
      );
      // Update the papers state with the fetched data
      setPapers(response.data);
      // Update pagination state if available in response
      setPagination((prev) => ({
        ...prev,
        totalItems: response.pagination?.total_items || 0,
        currentPage: response.pagination?.current_page || 1,
      }));
      console.log("Project papers fetched successfully:", response);

    } catch (err) {
      console.error("Error fetching papers:", err);
    }

  }, [projectId, currentPage, pageSize, paperStatusFilter])

  useEffect(() => {
    // This effect runs when the projectId changes
    if (projectId && currentPage && pageSize) {
      fetchPapers();
    }
  }, [projectId, currentPage, pageSize, paperStatusFilter, fetchPapers]);

  const value = {
    data,
    error,
    loading,
    refresh,
    fetchPapers,
    papers,
    pagination,
    setPagination,
    paperStatusFilter,
    setPaperStatusFilter,
  };

  return (
    <InitiativeContext.Provider value={value}>
      {children}
    </InitiativeContext.Provider>
  );
}

export { InitiativeContext };
export default InitiativeContextProvider;
